import script from "./UpcomingWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./UpcomingWidget.vue?vue&type=script&setup=true&lang=js"

import "./UpcomingWidget.vue?vue&type=style&index=0&id=59f942e5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f942e5"]])

export default __exports__